import React from 'react';
import Layout from '../components/Layout';
import AdminDebugPanel from '../components/AdminDebugPanel';
import AdminPermissionTest from '../components/AdminPermissionTest';
import AdminStatusTest from '../components/AdminStatusTest';

const DebugPage: React.FC = () => {
  return (
    <Layout>
      <div className="container mx-auto px-4 py-8">
        <h1 className="text-3xl font-bold text-gray-800 mb-6">系统调试页面</h1>
        <p className="text-gray-600 mb-8">
          此页面用于调试管理员权限问题。如果您使用 yebaobao888@gmail.com 账号登录但仍遇到403错误，
          请使用下面的调试面板检查您的权限状态。
        </p>
        <AdminStatusTest />
        
        <div className="mt-8">
          <AdminDebugPanel />
        </div>
        
        <div className="mt-8">
          <AdminPermissionTest />
        </div>
        
        <div className="mt-8 bg-blue-50 border border-blue-200 rounded-lg p-6">
          <h2 className="text-xl font-semibold text-blue-800 mb-4">问题排查步骤</h2>
          <ol className="list-decimal list-inside space-y-2 text-blue-700">
            <li>确认您已使用 yebaobao888@gmail.com 账号登录</li>
            <li>检查上方调试面板中的"管理员状态"是否都显示为"✅ 是管理员"</li>
            <li>如果管理员状态正确但插入权限测试失败，可能是RLS策略配置问题</li>
            <li>点击"测试插入"按钮尝试实际插入数据</li>
            <li>如果仍有问题，请检查Supabase控制台中的RLS策略设置</li>
          </ol>
        </div>
        
        <div className="mt-6 bg-gray-50 border border-gray-200 rounded-lg p-6">
          <h2 className="text-xl font-semibold text-gray-800 mb-4">可能的解决方案</h2>
          <ul className="list-disc list-inside space-y-2 text-gray-700">
            <li>清除浏览器缓存和localStorage</li>
            <li>重新登录账号</li>
            <li>检查网络连接</li>
            <li>确认Supabase服务状态正常</li>
            <li>验证RLS策略是否正确配置</li>
          </ul>
        </div>
      </div>
    </Layout>
  );
};

export default DebugPage;